/** Admin → Audit log (container): the break-glass audit, paged ("Load older"), filtered over what is loaded. */
import { useState } from 'react';
import { useAdminSites, useAudit } from '../../app/hooks.js';
import { AuditTable } from '../../components/admin/AuditTable.js';
import { type AuditFilter, NO_AUDIT_FILTER } from '../../lib/admin/view.js';
import { errorText } from './common.js';

export function AuditView() {
  const audit = useAudit();
  const sites = useAdminSites();
  const [filter, setFilter] = useState<AuditFilter>(NO_AUDIT_FILTER);
  return (
    <AuditTable
      entries={(audit.data?.pages ?? []).flatMap((p) => p.entries)}
      sites={(sites.data ?? []).map((s) => ({ id: s.siteId, name: s.name }))}
      filter={filter}
      loading={audit.isFetching && audit.data === undefined}
      error={errorText(audit.error)}
      hasMore={audit.hasNextPage}
      loadingMore={audit.isFetchingNextPage}
      onFilterChange={setFilter}
      onLoadMore={() => {
        void audit.fetchNextPage();
      }}
      onRetry={() => {
        void audit.refetch();
      }}
    />
  );
}
